import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

class PunchReport extends Component {

  handleEditClick(punchcardid, employee_id, date, punchin, punchout) {
    this.props.onOpenEditModal(punchcardid, employee_id, date, punchin, punchout);
  }

  handleDeleteClick(punchcardid) {
    this.props.onOpenDeleteModal(punchcardid);
  }

  renderPunch(punch) {
    return(
      <tr className={punch.punchout ? 'bg-white' : 'bg-red'}>
        <td>{punch.name}</td>
        <td>{punch.date}</td>
        <td>{punch.punchin}</td>
        <td>{punch.punchout}</td>
        <td>{ _.isNumber(punch.time) ? (punch.time).toFixed(2) + ' Hours' : ''}</td>
        <td><a href="#edit" onClick={event => this.handleEditClick(punch.punchcardid, punch.id, punch.date, punch.punchin, punch.punchout)}>Edit</a> / <a href="#delete" onClick={event => this.handleDeleteClick(punch.punchcardid)}>Delete</a></td>
      </tr>
    );
  }

  renderPunches(punches) {
    if (punches.length > 0) {
      return punches.map(( punch, index) => (
        this.renderPunch(punch)
      ));
    }
    else return [];
  }

  renderShift(shifts) {
    shifts = Object.values(shifts);
    return shifts.map( (shift, index) => {
        if (shift.totaltime > 0) {
          return (
            [this.renderPunches(shift.punches),
            <tr className="bg-white"><td className="right-text" colSpan="4"><b>Total</b></td><td><b>{(shift.totaltime).toFixed(2)} Hours</b></td><td>&nbsp;</td></tr>]
            );
        } else {
          return this.renderPunches(shift.punches)
        }
    });
  }

  renderNoShift(shifts) {
    shifts = Object.values(shifts);
    return shifts.map( (shift, index) => {
        return(
          <tr className="bg-white" key={index}>
            <td>{shift.name}</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td><a href="#add" onClick={event => this.handleEditClick('', shift.id, '', '', '')}>Add</a></td>
          </tr>
        );
    });
  }

  render() {
    if (this.props.report_day_from === '') {
      return (
        <div></div>
      );
    }

    if (_.isEmpty(this.props.reports.items) && (this.props.reports.items !== undefined)) {
      return <div>There is no data for this time period.</div>
    } else if (_.isEmpty(this.props.reports.items) === false ) {

      // Get the grand total of hours from each of the punches
      var grandtotal = 0;
      for (var item in this.props.reports.items.closedshift) {
        if (!this.props.reports.items.closedshift.hasOwnProperty(item)) continue;

        var obj = this.props.reports.items.closedshift[item];
        for (var prop in obj) {
            if(!obj.hasOwnProperty(prop)) continue;
            if (prop === "totaltime") {
              grandtotal += obj[prop];
            }
        }
      }

      return(
        <div>
          <input type="button" className="btn btn-primary b-a" onClick={event => this.handleEditClick('', this.props.reports.employees[0].employee_id, '', '', '')} value="Add Punch" />
          <br />
          <table className="table mb-0 table-bordered">
            <thead className="thead-inverse">
              <tr>
                <th colSpan="6">Created on: {this.props.report_created} <br /> Timesheet Report for {this.props.report_day_from} to {this.props.report_day_to}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th><b>Open Shifts</b></th>
                <th>&nbsp;</th>
              </tr>
              <tr className="bg-white">
                <td><b>Employee</b></td>
                <td><b>Date</b></td>
                <td><b>Time In</b></td>
                <td><b>Time Out</b></td>
                <td><b>Hours Worked</b></td>
                <td>&nbsp;</td>
              </tr>
              {this.renderShift(this.props.reports.items.openshift)}
              <tr>
                <th><b>Closed Shifts</b></th>
                <th>&nbsp;</th>
              </tr>
              <tr className="bg-white">
                <td><b>Employee</b></td>
                <td><b>Date</b></td>
                <td><b>Time In</b></td>
                <td><b>Time Out</b></td>
                <td><b>Hours Worked</b></td>
                <td>&nbsp;</td>
              </tr>
              {this.renderShift(this.props.reports.items.closedshift)}
              <tr className="bg-white"><td className="right-text" colSpan="4"><b>Grand Total</b></td><td><b>{(grandtotal).toFixed(2)} Hours</b></td><td>&nbsp;</td></tr>
              <tr>
                <th><b>No Shifts</b></th>
                <th>&nbsp;</th>
              </tr>
              <tr className="bg-white">
                <td><b>Employee</b></td>
                <td><b>Date</b></td>
                <td><b>Time In</b></td>
                <td><b>Time Out</b></td>
                <td><b>Hours Worked</b></td>
                <td>&nbsp;</td>
              </tr>
              {this.renderNoShift(this.props.reports.items.noshift)}
            </tbody>
          </table>
        </div>
      );
    }
  }
}

function mapStateToProps({ reports }) {
  return { reports };
}

export default connect(mapStateToProps, null)(PunchReport);



// WEBPACK FOOTER //
// ./src/containers/timesheets_report.js